// eslint-disable-next-line import/named
import { Outlet, createRoute, redirect } from "@tanstack/react-router";
import posthog from "posthog-js";

import {
  defaultPostAuthLandingKind,
  ensureDefaultPostAuthLandingPath,
} from "../../utils/defaultPostAuthLanding";
import { queryClient } from "../../utils/queryClient";
import { store } from "../../utils/store";
import { rootRoute } from "../root/route";

export const unauthLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "unauthenticated",
  async beforeLoad() {
    const { value: user } = store.getState().auth;

    if (user?.email) {
      // Pre-fix this was a bare `redirect()` (no `throw`), so the
      // bounce-an-authed-user-out-of-unauth-routes behavior was a
      // silent no-op. Adding `throw` here surfaces the intended
      // behavior. `LoginView` has its own already-authed handler
      // (LoginView.tsx:147-162) so the surface change at /login is
      // nil; the meaningful surface change is at /forgot-password
      // and other children of `unauthLayoutRoute`, which now
      // correctly bounce authed users away.
      //
      // Cache prime is required: this route is outside the
      // `authLayoutRoute` loader chain, so `brand-guidelines` and
      // `enterprises` are not guaranteed primed when an authed user
      // hits an unauth route. Without priming, an Ask-Puntt-enabled
      // user would silently fall through to `/tickets`.
      const target = await ensureDefaultPostAuthLandingPath(queryClient);
      posthog.capture("post_auth_default_landing", {
        site: "unauth_layout_bounce",
        target: defaultPostAuthLandingKind(),
      });
      throw redirect({ to: target });
    }
  },
  component: function Component() {
    return <Outlet />;
  },
});
